import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { formconfig } from '../configuration/formconfig/formconfig';
import { environment } from '../../environments/environment';
import { FormTemplate } from '../Template/formtemplate/formtemplate';
import { Database } from '../Master/database/database';
import { LocalService } from '../local.service';
  
let header = new HttpHeaders();
header = header.set('Content-Type', 'application/json; charset=utf-8')
.set('test', 'header 2 value');
@Injectable({
  providedIn: 'root'
})
export class FormrenderService {


  constructor(private httpClient: HttpClient,
    private localService: LocalService) { }
  baseUrl: string = environment.serviceUrl;


  getDatabase(): Observable<Database[]> {
    return this.httpClient.get<Database[]>(this.baseUrl + 'api/DatabaseApi')
  }

  getFormConfig(): Observable<formconfig[]> {
    return this.httpClient.get<formconfig[]>(this.baseUrl + 'api/FormConfigApi/');
  };

 

  Post(formData:FormData): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/FormRenderApi/add', formData, {  observe: 'response' })
  }

  Put(formData: FormData): Observable<any> {
    return this.httpClient.put<any>(this.baseUrl + 'api/FormRenderApi/Update', formData, {  observe: 'response' })
  }
  Delete(formdata: any): Observable<any> {
    //return this.httpClient.get<any>(this.baseUrl + 'api/FormRenderApi/activeordeactive/', formdata)
    return this.httpClient.post<any>(this.baseUrl + 'api/FormRenderApi/activeordeactive', formdata, { headers: header, observe: 'response' });
  }


   getmasterdetails(name): Observable<any> {
    return this.httpClient.get(
      this.baseUrl + 'api/FormRenderApi/getmasterdetails/' + name, { }
    );
  } 
  getmaster(): Observable<any> {
    return this.httpClient.get(
      this.baseUrl + 'api/FormRenderApi/getmaster/', {}
    );
  }
  getDocumentActivityLog(formconfigId: number, documentId: number): Observable<any> {
    var formData = formconfigId + '*' + documentId;
    return this.httpClient.get<any>(this.baseUrl + 'api/FormRenderApi/getDocumentActivityLog/'+ formData);
  };
  getFormRenderDocumentDetails(formconfigdetails: string): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/FormRenderApi/getFormRenderDocumentDetails/' + formconfigdetails);
  };
  GetAllGivenMasterDetails(tableid: string): Observable<any> {
    return this.httpClient.get(
      this.baseUrl + 'api/FormRenderApi/GetAllGivenMasterDetails/' + tableid, {}
    );
  }
  getStatenetFulltextDatabaseId(): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/CommonFunctionApi/GetStatenetFulltextDatabaseId');
  }
  getSelectedDocumentFormProfilesDetails(formconfigdetails: string): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/FormRenderApi/getSelectedDocumentFormProfilesDetails/' + formconfigdetails);
  }
  GetNonCaseLawFile(filename: string, dbName: string, formConfigId: string, documentId: string): Observable<any> {
    let queryParams = '?dbName=' + dbName + '&formConfigId=' + formConfigId + '&documentId=' + documentId;
    return this.httpClient.get<any>(this.baseUrl + 'api/FormRenderApi/GetNonCaseLawFile/' + filename + queryParams);
  }
  GetNonCaseLawFileNames(dbName: string, formConfigId: string, documentId: string): Observable<any> {
    let queryParams = '?dbName=' + dbName + '&formConfigId=' + formConfigId + '&documentId=' + documentId;
    return this.httpClient.get<any>(this.baseUrl + 'api/FormRenderApi/GetNonCaseLawFileNames/' + queryParams);
  }
  AddDocumentActivityLogview(data: any): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/FormRenderApi/AddDocumentActivityLogview', data, { headers: header, observe: 'response' });
  }
  sendtoautolog(formconfigdetails: string): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/FormRenderApi/SendtoAutolog/' + formconfigdetails);
  };
  LoadProductLine(productid: number, product: string, active: number): Observable<any> {

    return this.httpClient.get<any>(this.baseUrl + 'api/FormRenderApi/Loadproductddl/' + productid + '/' + product + '/' + active);
  };
  LoadProduct(productid: number, product: string, active: number,apitoken:string): Observable<any> {

    const headers = { 'Authorization': 'Bearer '+apitoken, 'My-Custom-Header': apitoken };
      return this.httpClient.get<any>(this.baseUrl + 'api/FormRenderApi/Loadproduct/' 
      + productid + '/' + product + '/' + active ,{ headers });
  };
  LoadProductddl(productid: number, product: string, active: number): Observable<any> {
    
    return this.httpClient.get<any>(this.baseUrl + 'api/FormRenderApi/Loadproductddl/' + productid + '/' + product + '/' + active);
  };

  sendtoautologproduct(formconfigdetails: string): Observable<any> {

    return this.httpClient.post<any>(this.baseUrl + 'api/FormRenderApi/sendtoautologproduct', formconfigdetails, { headers: header, observe: 'response' })
  };
  createShortenURLDts(ShortenURLDts:any):Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/FormRenderApi/createShortenURLDts', 
    ShortenURLDts, { headers: header, observe: 'response'});
  };
  getShortenURLDts(URLDts:any):Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/CommonFunctionApi/tinyurl?url='+URLDts) 
  };
 

}
